import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

declare module '@mui/material/Select' {
  interface BaseSelectProps {
    'data-is-ai-prefilled'?: boolean
  }
}

export const MuiSelect: Components<Omit<Theme, 'components'>>['MuiSelect'] = {
  styleOverrides: {
    root: ({ 'data-is-ai-prefilled': dataIsAiPrefilled, theme }) => ({
      '&:not(.Mui-disabled)': {
        backgroundColor: dataIsAiPrefilled ? theme.palette.secondary.light : theme.palette.neutralLight[0],
      },
    }),
    select: {
      padding: '8.5px 14px',
      '.MuiSelect-select &.Mui-disabled': {
        color: palette.neutralLight[900],
        backgroundColor: palette.neutralLight[50],
        border: '1px solid rgba(0,0,0, 0.23)',
      },
      '&.Mui-disabled': {
        WebkitTextFillColor: palette.neutralLight[900],
      },
    },
  },
}
